(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scispark-home"] && !Shopify.designMode) return;
  try {
    
(()=>{const cd=document.querySelector('[data-countdown]');if(cd){const duration=3*3600+47*60+22;let end;try{end=Number(sessionStorage.getItem('ss-home-sale-end'));if(!end||end<=Date.now())end=Date.now()+duration*1000;sessionStorage.setItem('ss-home-sale-end',String(end))}catch(e){end=Date.now()+duration*1000}const render=()=>{const s=Math.max(0,Math.ceil((end-Date.now())/1000)),h=String(Math.floor(s/3600)).padStart(2,'0'),m=String(Math.floor((s%3600)/60)).padStart(2,'0'),x=String(s%60).padStart(2,'0');cd.textContent=`${h}:${m}:${x}`};render();setInterval(render,1000)}const buy=document.querySelector('[data-mobile-buy]');addEventListener('scroll',()=>buy?.classList.toggle('show',scrollY>700),{passive:true});const exit=document.querySelector('[data-exit]');let shown;try{shown=sessionStorage.getItem('ss-exit-shown')}catch(e){}document.addEventListener('mouseleave',e=>{if(!shown&&e.clientY<=0&&exit){shown='1';try{sessionStorage.setItem('ss-exit-shown','1')}catch(err){}exit.showModal()}},{once:true});document.querySelector('[data-close-exit]')?.addEventListener('click',()=>exit.close())})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scispark-product"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const main=document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-gallery-src]').forEach(button=>button.addEventListener('click',()=>{
    document.querySelectorAll('[data-gallery-src]').forEach(other=>{other.classList.remove('active');other.setAttribute('aria-pressed','false')});
    button.classList.add('active');button.setAttribute('aria-pressed','true');
    if(main){main.removeAttribute('srcset');main.src=button.dataset.gallerySrc;main.alt=button.dataset.galleryAlt||main.alt}
  }));
  const form=document.getElementById('SciSparkProductForm');
  if(!form)return;
  const quantity=form.querySelector('[name="quantity"]');
  const safeQuantity=()=>Number.isFinite(Number(quantity?.value))?Math.max(1,Math.floor(Number(quantity.value))):1;
  document.querySelector('[data-qty-minus]')?.addEventListener('click',()=>{if(quantity)quantity.value=Math.max(1,safeQuantity()-1)});
  document.querySelector('[data-qty-plus]')?.addEventListener('click',()=>{if(quantity)quantity.value=safeQuantity()+1});
  const notice=document.querySelector('[data-cart-notice]');
  const error=document.querySelector('[data-cart-error]');
  const labels=form.querySelector('[data-cart-labels]').dataset;
  const buttons=[...document.querySelectorAll('.ssp-add,[form="SciSparkProductForm"]')];
  let adding=false;
  form.addEventListener('submit',async event=>{
    if(event.submitter?.closest('.shopify-payment-button'))return;
    event.preventDefault();
    if(adding||!form.reportValidity())return;
    adding=true;form.setAttribute('aria-busy','true');
    notice.hidden=true;error.hidden=true;
    const states=buttons.map(button=>({text:button.textContent,disabled:button.disabled}));
    buttons.forEach(button=>{button.disabled=true;button.textContent=labels.adding});
    const root=window.Shopify?.routes?.root||'/';
    const controller=new AbortController();
    const timeout=setTimeout(()=>controller.abort(),20000);
    let succeeded=false;
    try{
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form),signal:controller.signal});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||labels.error);
      succeeded=true;
      notice.hidden=false;
      notice.scrollIntoView({behavior:'smooth',block:'nearest'});
      buttons.forEach(button=>button.textContent=labels.added);
      fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(response=>response.ok?response.json():null).then(cart=>{
        if(cart&&Number.isInteger(cart.item_count))document.querySelectorAll('.ss-cart-count').forEach(count=>count.textContent=cart.item_count);
      }).catch(()=>{});
    }catch(err){
      error.textContent=err.name==='AbortError'||err instanceof TypeError||err instanceof SyntaxError?labels.connection:err.message||labels.error;
      error.hidden=false;
      error.scrollIntoView({behavior:'smooth',block:'nearest'});
    }finally{
      clearTimeout(timeout);
      const restore=()=>{buttons.forEach((button,index)=>{button.disabled=states[index].disabled;button.textContent=states[index].text});adding=false;form.removeAttribute('aria-busy')};
      if(succeeded)setTimeout(restore,900);else restore();
    }
  });
  const h=document.querySelector('[data-product-hours]'),m=document.querySelector('[data-product-minutes]'),s=document.querySelector('[data-product-seconds]');if(h&&m&&s){const duration=16*3600+44*60+59;let end;try{end=Number(sessionStorage.getItem('ss-product-sale-end'));if(!end||end<=Date.now())end=Date.now()+duration*1000;sessionStorage.setItem('ss-product-sale-end',String(end))}catch(e){end=Date.now()+duration*1000}const render=()=>{const left=Math.max(0,Math.ceil((end-Date.now())/1000));h.textContent=String(Math.floor(left/3600)).padStart(2,'0');m.textContent=String(Math.floor(left%3600/60)).padStart(2,'0');s.textContent=String(left%60).padStart(2,'0')};render();setInterval(render,1000)}})();


  } catch(e) { console.error(e); }
})();
})();
